import { Layout } from 'antd';
import React from 'react';

import classes from './Footer.module.less';

import useConfig from 'hooks/useConfig';

const { Footer: AntdFooter } = Layout;

const Footer = () => {
	const config = useConfig();

	return (
		<AntdFooter className={classes.container}>
			Сервис поддержки © {new Date().getFullYear()} {config.appName}
		</AntdFooter>
	);
};

export default Footer;
